<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="商品名称：">
                <el-input v-model="searchForm.oldIccid" @keyup.enter.native="getBuyCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="姓名：">
                <el-input v-model="searchForm.takeNickname" @keyup.enter.native="getBuyCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号：">
                <el-input v-model="searchForm.takePhone" @keyup.enter.native="getBuyCardListHandler" clearable></el-input>
            </el-form-item>


            <el-form-item label="处理结果：">
                <el-select v-model="searchForm.disposeState" clearable>
                    <el-option value="1" label="待审核"></el-option>
                    <el-option value="2" label="拒绝"></el-option>
                    <el-option value="3" label="通过"></el-option>
                </el-select>
            </el-form-item>
          
            <el-form-item label="申请时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain @click="getBuyCardListHandler" icon="el-icon-search">搜索查询</el-button>
                  <el-button type="success" plain @click="getBuyCardUrlHandler">生成专属购卡链接</el-button>
                  <el-button type="success" plain @click="confirmExportDialogVisible = true"  icon="el-icon-download">导出Excel</el-button>
                <el-button type="primary" plain @click="showImportApply"   icon="el-icon-s-ticket">导入Excel</el-button>

            </el-form-item>
        </el-form>

        <!-- <el-table :data="tbpg.tableData"
		 :cell-style="cellStyle" :header-cell-style="headCellStyle">           
            <el-table-column align="center" prop="changeCmccSimName" label="新卡类型" width="170"></el-table-column>
            <el-table-column align="center" prop="takeNickname" label="收货人姓名" width="90"></el-table-column>
            <el-table-column  align="center" prop="takePhone" label="收货人电话" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="收货人地址" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{scope.row.pcaAddress + scope.row.takeAddress}}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="createTime" label="申请时间" width="140"></el-table-column>
            <el-table-column align="center" prop="newIccid" label="新ICCID号" width="170"></el-table-column>
            <el-table-column align="center" prop="iccidSize" label="购买数量" width="90"></el-table-column>
            <el-table-column align="center" prop="agentPathName" label="层级关系" width="90"></el-table-column>
            <el-table-column  align="center" prop="disposeNickname" label="处理人" width="90"></el-table-column>
            <el-table-column align="center" prop="disposeTime" label="处理时间" width="140"></el-table-column>
            <el-table-column align="center" prop="disposeRemark" label="处理描述" width="120" ></el-table-column>
            <el-table-column align="center" prop="disposeStateName" label="处理状态" width="90"></el-table-column>
            <el-table-column align="center" fixed="right" label="操作" width="90">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.disposeState != 3" type="text" size="small" @click="showDealWithBuyCard(scope.row)">处理</el-button>
                </template>                  
            </el-table-column>
        </el-table>                   -->
        <el-table :data="tbpg.tableData" border  >     
            <el-table-column type="index" label="序号" align="center"></el-table-column>  
            <el-table-column align="center" prop="changeCmccSimName" label="商品名称" width="170"></el-table-column>
            <el-table-column prop="takeNickname" label="收货人姓名" width="110" align="center"></el-table-column >
            <el-table-column prop="takePhone" label="手机号"   width="110" align="center"></el-table-column>   
            <el-table-column prop="takeInfos" label="收货地址" width="200"  align="center">
                  <template slot-scope="scope">
                      <div style=" white-space: normal;word-break: break-all; overflow: hidden;">  {{scope.row.pcaAddress + scope.row.takeAddress}}</div>
                  </template>
            </el-table-column>
            <el-table-column align="center" prop="createTime" label="申请时间" width="150" ></el-table-column>
            <el-table-column align="center" prop="newIccid" label="新卡号"></el-table-column>
            <el-table-column align="center" prop="iccidSize" label="购买数量"  width="90"></el-table-column>
             <el-table-column  align="center"  label="层级关系">
                 <template v-slot="scope">
                    <el-tooltip  class="item" effect="dark" :content="scope.row.agentPathName">
                        <p style="color:teal"> {{scope.row.agentPathName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column> 
            <!-- <el-table-column  align="center" prop="disposeNickname" label="处理人"></el-table-column>
            <el-table-column align="center" prop="disposeTime" label="处理时间" ></el-table-column> -->
            <el-table-column align="center" prop="disposeRemark" label="快递备注"  ></el-table-column>
            <el-table-column  align="center"  label="处理状态">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.disposeState==0|| scope.row.disposeState==1" class="item" effect="dark" :content="scope.row.disposeRemark">
                        <p style="color:#409EFF"> {{scope.row.disposeStateName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" :content="scope.row.disposeRemark">
                        <p style="color:teal"> {{scope.row.disposeStateName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column> 
          
             <el-table-column align="center" fixed="right" label="操作" width="90">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.disposeState != 3" type="text" size="small" @click="showDealWithBuyCard(scope.row)">处理</el-button>
                </template>                  
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

        <el-dialog :append-to-body="true"  title="处理买卡" :visible.sync="dealWithBuyCardVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="dealWithForm" :model="dealWithForm" label-width="120px">
                <el-form-item label="id：">
                    <span>{{ dealWithForm.id }}</span>
                </el-form-item>
                <el-form-item label="新卡号：" prop="newIccid">
                    <el-input v-model.trim="dealWithForm.newIccid"></el-input>
                </el-form-item>
                <el-form-item label="处理结果：">
                    <el-radio-group v-model="dealWithForm.disposeState">
                        <el-radio :label="3">通过</el-radio>
                        <el-radio :label="2">拒绝</el-radio>
                        <el-radio :label="1">待审核</el-radio> 
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="快递备注：">
                    <el-input v-model.trim="dealWithForm.disposeRemark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureDealWithBuyCardHandler">确 定</el-button>
            </div> 
        </el-dialog>

         <el-dialog :append-to-body="true"  title="购卡链接" :visible.sync="shareImgs" width="700px" @close="cancel" :close-on-click-modal="false">
            <div style="text-align: center; padding: 10px 0; color: #F56C6C;">注：请保存以下二维码进行推广商品，商品推广后 可在客服管理->购卡里面查询订单</div>
            <div style="text-align: center; width:100%;">               
                <img  :src="getImgUrl() +  groupImg" alt="" width="300px" height="300px" style="margin: 0 auto;">  
            </div>
            <div style="text-align: center; padding: 10px 0; color: #F56C6C;">推广链接  {{urls}}</div>
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" @click="copy()" class="copy_url" :data-clipboard-text="urls">复制链接</el-button>
                <el-button type="danger" @click="openLink()">打开链接</el-button>
            </div>            
        </el-dialog>






        <el-dialog :append-to-body="true"  title="处理数据" :visible.sync="importVisible" width="600px" :close-on-click-modal="false">
            <el-form :model="dealWithForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('bindPhone/export/changeSim')" :headers="setHeader()" :limit="1" :auto-upload="false" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                    </el-upload>                        
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importCancel">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler">确 定</el-button>
            </div> 
        </el-dialog> 
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportApplyHandler">确 定</el-button>
            </span>
        </el-dialog>



    </div>
</template>
<script>
import { getBuyCardList, dealWithBuyCard } from '@/api/csm.js'
import common from '@/utils/common.js'
import Clipboard from 'clipboard';
export default {
    data(){
        return {
            importVisible:false,
            confirmExportDialogVisible:false,
            urls:'',
            groupImg:'',
            shareImgs:false,
            searchForm: {
                disposeState: '',
                oldIccid: '',
                time: '',
                changeCmccSim: '',
                seeAll: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            dealWithBuyCardVisible: false,
            dealWithForm: {
                disposeState: '',
                newIccid: '',
                disposeRemark: '',
                id: ''
            }
        }
    },
    methods: {
        importApplyHandler(){
            this.$refs.upload.submit();
        },
        handleSuccess(res){
            if(res.code == 200){
                this.importVisible = false;
                this.getBuyCardListHandler();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            } 
        },

        showImportApply(){
            this.importVisible = true;
        },
        exportApplyHandler(){
            var data = JSON.parse(JSON.stringify(this.searchForm));
            if(data.time != ''){
                data.startTimeString = data.time[0] + ' 00:00:00'; 
                data.endTimeString = data.time[1] + ' 23:59:59';
            }else{
                data.startTimeString = '';
                data.endTimeString = '';
            }
            delete data.time; 

            this.exportExcel('/mould/download/changeSim/buy', data);
            this.confirmExportDialogVisible = false;
        },


         //直接打开链接
        openLink(){
            window.open(this.urls)
        },
        //复制功能
        copy() {
            var clipboard = new Clipboard('.copy_url')
            clipboard.on('success', e => {
              this.$message.success('复制成功');
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.success('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        //改变指定列的样式
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 7) {
                // 指定列号
                return 'color:red'
            } else {
                return ''
            }
        },
        
         getBuyCardUrlHandler($event){
            common.sysRequest('pkg/group/share/urls', {}, 'post').then(res => {
                if(res.data.code == 200){
                  this.groupImg=res.data.data.img;
                  this.urls=res.data.data.url;
                  this.shareImgs=true;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        
        
        headCellStyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 7) {
                // 指定列号
                return 'color:red'
            } else {
                return ''
            }
        },
        getBuyCardListHandler($event){
            // if(this.searchForm.seeAll == ''){
            //     this.$message.error('请先选择查看下级');
            //     return;
            // }
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getBuyCardList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getBuyCardListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getBuyCardListHandler();
        },
        showDealWithBuyCard(row){
            this.dealWithBuyCardVisible = true;
            for(var key in this.dealWithForm){
                this.dealWithForm[key] = row[key]
            }
        },
        cancel(){
            this.shareImgs=false;
            this.dealWithBuyCardVisible = false;
        },
        sureDealWithBuyCardHandler(){
            this.$refs.dealWithForm.validate(valid => {
                if(valid){
                    var data = this.dealWithForm;
                    dealWithBuyCard(data).then(res => {
                        if(res.data.code == 200){
                            this.dealWithBuyCardVisible = false;
                            this.getBuyCardListHandler();
                            this.$message.success(res.data.message);
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        }
    },
    created () {
        this.getBuyCardListHandler();
    }
}
</script>
<style lang="less" scoped>
</style>

